import { DesignElementBase, DesignElementGroupableRequiredPart } from "./base";
import { PageBlockDataV2 } from "./data";
import { z } from "zod";
//
// Element
//
export const PageBlockV2 = DesignElementBase.extend(DesignElementGroupableRequiredPart.shape).extend({
    data: PageBlockDataV2,
});
//
// Editor Model
//
export const PageBlockEditorModelV2 = z.object({
    id: z.string(),
    type: z.literal("Block"),
    data: PageBlockDataV2,
});
